///<reference path="../../employee/sections/employee.licensesInsurance.section.ts"/>
module Meevo.Plugins.Teachers {
    "use strict";

    export class LicensesInsuranceSection extends Meevo.Plugins.Employee.LicensesInsuranceSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherLicenseInsurances;
        }
    }
}